export default __webpack_public_path__ + "static/media/phone_in_talk.9513cac8.svg";